import { createSlice, nanoid, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@urc-ui/store/types';
import type { SnackbarMessage, SnackbarState } from './types';

const initialState: SnackbarState = {
  messages: []
};

export const SNACKBAR_LIMIT = 3;

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    addMessage(state, action: PayloadAction<SnackbarMessage>) {
      state.messages.push({ ...action.payload, id: nanoid() });
    },
    removeMessage(state, action: PayloadAction<string>) {
      const index = state.messages.findIndex(message => message.id === action.payload);
      if (index !== -1) {
        state.messages.splice(index, 1);
      }
    },
    removeFirstMessage(state) {
      state.messages.shift();
    }
  }
});

export const { addMessage, removeMessage, removeFirstMessage } = snackbarSlice.actions;

export const selectSnackbars = (state: RootState) => state.snackbarMessages.messages;
export const selectSnackbarsCount = (state: RootState) => state.snackbarMessages.messages.length;

export default snackbarSlice.reducer;
